<template>
    <div class="container">
        <div class="fond">
            <slot name="fond"></slot>
        </div>
      <div class="float-image">
        <slot name="float-image"></slot>
      </div>
    </div>
</template>

<script>
  export default {

  }
</script>

<style scoped>
  .container {
    height: 80%;
    width: 80%;
    position: relative;
  }

  .fond {
    height: 100%;
    width: 100%;
  }
  .fond img {
    height: 100%;
    width: 100%;
  }

  .float-image {
    height: 90%;
    max-width: 100%;
    width: 80%;
    position: absolute;
    left: 50%;
    transform: translateX(-60%);
    bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .float-image img {
    max-height: 100%;
    max-width: 100%;
    height: auto;
    width: auto;

    -webkit-animation: orbit-effect 5s linear infinite;
    -moz-animation: orbit-effect 5s linear infinite;
    -o-animation: orbit-effect 5s linear infinite;
    animation: orbit-effect 5s linear infinite;
  }

  @-webkit-keyframes orbit-effect {
    from { -webkit-transform: rotate(0deg) translateX(5px) rotate(0deg); }
    to   { -webkit-transform: rotate(360deg) translateX(5px) rotate(-360deg); }
  }
  @-moz-keyframes orbit-effect {
    from { -webkit-transform: rotate(0deg) translateX(5px) rotate(0deg); }
    to   { -webkit-transform: rotate(360deg) translateX(5px) rotate(-360deg); }
  }
  @-o-keyframes orbit-effect {
    from { -webkit-transform: rotate(0deg) translateX(5px) rotate(0deg); }
    to   { -webkit-transform: rotate(360deg) translateX(5px) rotate(-360deg); }
  }
  @keyframes orbit-effect {
    from { -webkit-transform: rotate(0deg) translateX(10px) rotate(0deg); }
    to   { -webkit-transform: rotate(360deg) translateX(10px) rotate(-360deg); }
  }
</style>



// WEBPACK FOOTER //
// src/components/societe/ImageFloatSociete.vue